import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectSubscriptions = (state: RootState) =>
  state.rootReducer.subscriptionsStore.subscriptions;

export const selectIsLoadingSubscriptions = (state: RootState) =>
  state.rootReducer.subscriptionsStore.isLoadingSubscriptions;

export const selectSubscriptionsState = createSelector(
  selectSubscriptions,
  selectIsLoadingSubscriptions,
  (subscriptions, isLoadingSubscriptions) => ({
    subscriptions,
    isLoadingSubscriptions
  })
);
